/**
 * Brown - small storefront tweaks (JavaScript side).
 *
 * Two independent blocks. Deleting either one leaves the other working.
 * Loaded from layout/theme.liquid just before the closing body tag.
 */

/* ------------------------------------------------------------------
 * 1. Rewards link in the footer.
 *
 * The Smile launcher button is hidden by brown-tweaks.css, so this puts
 * a quiet "Rewards" link at the end of the footer menu instead. Smile
 * opens its panel on the #smile-home hash, in place, with no page
 * navigation - so it works from anywhere on the site.
 *
 * It is added by script rather than as a Shopify navigation menu item
 * because a menu item cannot hold a bare hash link: Shopify turns it
 * into a homepage URL, which would bounce the customer off the page
 * they are on.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  var HASH = '#smile-home';
  var LABEL = 'Rewards';
  var LIST = '.footer .footer__block--links ul.unstyled-list';

  function addRewardsLink() {
    var list = document.querySelector(LIST);
    if (!list) return;
    if (list.querySelector('a[href="' + HASH + '"]')) return;

    var sibling = list.querySelector('a');
    var item = document.createElement('li');
    var link = document.createElement('a');

    link.href = HASH;
    link.textContent = LABEL;
    link.className = sibling ? sibling.className : 'link-faded';

    item.appendChild(link);
    list.appendChild(item);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addRewardsLink, { once: true });
  } else {
    addRewardsLink();
  }
})();

/* ------------------------------------------------------------------
 * 2. In stock follows size on collection pages.
 *
 * Shopify filters variants, collections count products. So "size L"
 * on its own returns every product that HAS an L - including the ones
 * where the L is sold out. The customer clicks in, finds L greyed out,
 * and leaves. Turning on the availability filter alongside the size is
 * what makes "L" mean "L you can actually buy".
 *
 * Doing it automatically also fixes the cosmetic complaint: the In
 * stock chip now only ever appears when it is doing something.
 *
 * Two halves, because the theme offers two ways to change a filter:
 *   - the checkboxes in the sidebar and the mobile drawer, handled on
 *     change;
 *   - the active-filter chips, which are plain links whose href means
 *     "everything except me", handled on click.
 * Both listeners are on document in the capture phase, so they run
 * before Prestige reads the form or follows the link.
 *
 * Deliberate simplification: no memory of whether the customer or this
 * script turned availability on. Removing the last size clears it
 * either way. The alternative needs state that survives every section
 * re-render, and the edge case it buys - a customer who set In stock
 * by hand, then added a size, then removed that size - loses them
 * nothing they cannot re-tick in one click.
 *
 * Scoped to size on purpose - SIZE below is the only filter it
 * watches.
 * ------------------------------------------------------------------ */
(function () {
  'use strict';

  var SIZE = 'filter.v.option.size';
  var AVAILABILITY = 'filter.v.availability';

  function isSizeInput(el) {
    return !!el && typeof el.name === 'string' && el.name.indexOf(SIZE) === 0;
  }

  function anySizeChecked(form) {
    return !!form.querySelector('input[name^="' + SIZE + '"]:checked');
  }

  // Sidebar and drawer are two separate forms holding the same filters.
  // Whichever one submits, both should agree.
  function setAvailability(state) {
    var boxes = document.querySelectorAll(
      'facets-form input[name="' + AVAILABILITY + '"]'
    );
    Array.prototype.forEach.call(boxes, function (box) { box.checked = state; });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!isSizeInput(input)) return;

    var form = input.closest && input.closest('facets-form');
    if (!form) return;

    setAvailability(anySizeChecked(form));
  }, true);

  document.addEventListener('click', function (event) {
    var link = (event.target && event.target.closest)
      ? event.target.closest('a[href]')
      : null;
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (href.indexOf('filter.') === -1) return;

    var here, next;
    try {
      here = new URL(location.href);
      next = new URL(link.href, location.origin);
    } catch (e) {
      return;
    }

    // Only act when this click is what removes the last size filter.
    if (!here.searchParams.has(SIZE)) return;
    if (next.searchParams.has(SIZE)) return;
    if (!next.searchParams.has(AVAILABILITY)) return;

    next.searchParams.delete(AVAILABILITY);
    link.setAttribute('href', next.pathname + next.search);
  }, true);
})();
